import React, { useEffect } from "react"
import { useHistory, useParams } from "react-router-dom"
import { startsWith } from 'lodash'

export const PhotographerQuickLinkRouter = () => {

    const { photographerNickNameZa, photographerNickNameAu, photographerNickNameUs } = useParams()
    const history = useHistory()

    let country_code
    let nick_name
    if ( photographerNickNameZa ) {
        country_code = "za"
        nick_name = photographerNickNameZa
    } else if ( photographerNickNameAu ) {
        country_code = "au"
        nick_name = photographerNickNameAu
    } else if ( photographerNickNameUs ) {
        country_code = "us"
        nick_name = photographerNickNameUs
    }
    
    useEffect(() => {
         if ( ! startsWith(nick_name, "customer") ) {
            window.location.href = `/${country_code}/customer/map/${nick_name}/`
        }
    }, [nick_name])
    
    return (
        <div>Redirecting to the galleries of {nick_name}...</div>
    )
    
}
